"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var GA4EventFactory = /*#__PURE__*/function () {
  function GA4EventFactory(eventType) {
    _classCallCheck(this, GA4EventFactory);
    this.eventType = eventType;
  }

  /* istanbul ignore next*/
  return _createClass(GA4EventFactory, [{
    key: "create",
    value: function create(eventObjects) {
      var dataLayer = window.dataLayer || [];
      var data = {};
      if (this.eventType) {
        data.event = this.eventType;
      }
      dataLayer.push(_objectSpread(_objectSpread({}, data), eventObjects));
    }
  }]);
}();
/* istanbul ignore next*/
if (typeof exports !== 'undefined') {
  module.exports = GA4EventFactory;
}
var cookieController = function () {
  /* eslint-disable-line no-unused-vars */
  function getCookieName(scope, name) {
    return scope + '_' + name;
  }
  function getRegEx(scope, name) {
    var cookieName = getCookieName(scope, name);
    return new RegExp('(^| )' + cookieName + '=([^;]+)');
  }
  var cookieFactory = /*#__PURE__*/_createClass(function cookieFactory(layer, module) {
    _classCallCheck(this, cookieFactory);
    this.scope = layer + '_' + module;
    this.get = function (name) {
      var regEx = getRegEx(this.scope, name);
      var match = document.cookie.match(regEx);
      return match ? match[2] : null; /* eslint-disable-line no-magic-numbers */
    };
  });
  function initialize(layer, module) {
    return new cookieFactory(layer, module);
  }
  return {
    initialize: initialize
  };
}();

/**
 * Ecommerce Cookie Controller class sets, gets and deletes cookie.
 */
var ecommerceCookieController = /*#__PURE__*/function () {
  /**
   * Constructor for ecommerceCookieController
   * @param {location} address
   * @param {array} paramNames
   * @param {String} cookieName
   * @param {date} expiration
   * @param {String} domain
   */
  function ecommerceCookieController(address, paramNames, cookieName, expiration, domain) {
    _classCallCheck(this, ecommerceCookieController);
    this.address = address;
    this.reqParams = paramNames;
    this.cookieName = cookieName;
    this.expiration = expiration;
    this.domain = domain;
  }

  /**
   * Returns a cookie's values with the given name, if not found, returns -1.
   */
  return _createClass(ecommerceCookieController, [{
    key: "getCookie",
    value: function getCookie() {
      var name = this.cookieName + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var splitCookie = decodedCookie.split(';');
      for (var i = 0; i < splitCookie.length; i++) {
        var c = splitCookie[i];
        c = c.trim();
        if (c.indexOf(name) === 0) {
          return c.split('=')[1];
        }
      }
      return '';
    }
    /**
    * delete the cookie by giving it an expiration date in the past
    */
  }, {
    key: "deleteCookie",
    value: function deleteCookie() {
      document.cookie = this.cookieName + "=; deleted=true;expires=" + this.expiration.toUTCString() + ";path=/; domain=" + this.domain + ";";
    }

    /**
     * Performs cookie checks and overwrites variables based on input
     * @param {String} cookieValue
     */
  }, {
    key: "runWithoutFetch",
    value: function runWithoutFetch(cookieValue) {
      this.fetchedParams = cookieValue;
      this.setCookie(this.fetchedParams, this.domain);
    }

    /**
     * Sets a cookie for the document based on the given parameters.
     * @param {string} cookieValues
     * @param {string} domain
     */
  }, {
    key: "setCookie",
    value: function setCookie(cookieValues, domain) {
      var expires = "expires=" + this.expiration.toUTCString();
      var domainString = domain === "" ? domain : "domain=" + domain + ";";
      document.cookie = this.cookieName + "=" + encodeURIComponent(cookieValues) + ";" + expires + ";path=/;" + domainString;
    }
  }]);
}(); // export as a module for unit testing
if (typeof exports !== 'undefined') {
  module.exports = ecommerceCookieController;
}

/* eslint-disable class-methods-use-this */
/* global SnhuCookieUtil */
var CookieProvider = /*#__PURE__*/function () {
  function CookieProvider() {
    _classCallCheck(this, CookieProvider);
  }
  return _createClass(CookieProvider, [{
    key: "getValueAsString",
    value: function getValueAsString(name) {
      if (!name) {
        return '';
      }
      return new SnhuCookieUtil(name).getCookie();
    }
  }, {
    key: "getValueAsJson",
    value: function getValueAsJson(name) {
      if (!name) {
        return {};
      }
      var cookieUtil = new SnhuCookieUtil(name);
      cookieUtil.getCookieValues();
      return cookieUtil.cookieValues;
    }
  }, {
    key: "getCookieValue",
    value: function getCookieValue(name, value) {
      if (!name) {
        return {};
      }
      var cookieUtil = new SnhuCookieUtil(name);
      cookieUtil.getCookieValues();
      return cookieUtil.getCookieValue(value);
    }
  }, {
    key: "setCookie",
    value: function setCookie(name, value, duration) {
      new SnhuCookieUtil(name).setCookie(value, duration);
    }
  }, {
    key: "setCookieFromJson",
    value: function setCookieFromJson(name, jsonData) {
      if (!name || !jsonData) {
        return '';
      }
      var cookieString = '';
      Object.keys(jsonData).forEach(function (key) {
        cookieString += ',' + key + ':' + jsonData[key];
      });
      if (cookieString.length < 0) {
        return '';
      }
      this.setCookie(name, cookieString.substring(1));
      return cookieString.substring(1);
    }
  }, {
    key: "checkCookie",
    value: function checkCookie(name) {
      var cookieExists = new SnhuCookieUtil(name).getCookie();
      return cookieExists;
    }
  }, {
    key: "deleteCookie",
    value: function deleteCookie(name) {
      var expiration = -1;
      new SnhuCookieUtil(name).setCookie('', expiration);
    }
  }]);
}(); // Export as a module for unit testing
if (typeof exports !== 'undefined') {
  module.exports = CookieProvider;
}
var VertTabsClass = /*#__PURE__*/function () {
  function VertTabsClass(groupNode) {
    _classCallCheck(this, VertTabsClass);
    this.tabsGroup = groupNode;
    this.tabAccordionTriggers = null;
    this.tabNav = null;
    this.tabs = [];
    this.firstTab = null;
    this.lastTab = null;
    this.tabPanels = [];
    this.openPanels = [];
    this.isMobile = true; // mobile first!
    this.windowResizeDelay = 100;
  }

  /**
   * Debounce function to limit the number of times a function is called
   * @param {*} func the function to be debounced
   * @param {*} wait amount of time to wait before executing the function
   * @returns
   */
  // eslint-disable-next-line class-methods-use-this
  return _createClass(VertTabsClass, [{
    key: "debounce",
    value: function debounce(func, wait) {
      var timeout;
      return function executedFunction() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        var later = function later() {
          clearTimeout(timeout);
          func.apply(void 0, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }
  }, {
    key: "addRemoveOpenPanels",
    value: function addRemoveOpenPanels(panel, add) {
      if (add) {
        this.openPanels.push(panel);
        return;
      }
      var index = this.openPanels.indexOf(panel);
      if (index > -1) {
        this.openPanels.splice(index, 1);
      }
    }
  }, {
    key: "setActiveTab",
    value: function setActiveTab(currentTab) {
      var _this = this;
      this.tabs.forEach(function (tab, i) {
        if (currentTab === tab) {
          tab.setAttribute('aria-selected', 'true');
          tab.tabIndex = 0;
          _this.tabPanels[i].hidden = false;
        } else {
          tab.setAttribute('aria-selected', 'false');
          tab.tabIndex = -1;
          _this.tabPanels[i].hidden = true;
        }
      });
    }
  }, {
    key: "hideShowPanel",
    value: function hideShowPanel(active, target, hideShow) {
      active.setAttribute('aria-expanded', !hideShow ? 'true' : 'false');
      if (target.hasAttribute('aria-controls')) {
        this.tabsGroup.querySelector('[id="' + target.getAttribute('aria-controls') + '"]').hidden = hideShow;
      }
    }
  }, {
    key: "handleTargetClick",
    value: function handleTargetClick(e) {
      var target = e.target;
      if (target.hasAttribute('data-tab-toggle-trigger')) {
        // Check if the current toggle is expanded
        var isExpanded = target.getAttribute('aria-expanded') === 'true';
        var active = this.tabsGroup.querySelector('[aria-expanded="true"]');

        // Without allowMultiple, close the open accordion
        if (!this.allowMultiple && active && active !== target) {
          if (!this.allowToggle) {
            active.removeAttribute('aria-disabled');
          }
          this.hideShowPanel(active, target, true);
          this.addRemoveOpenPanels(target.getAttribute('aria-controls'), false);
        }
        if (!isExpanded) {
          // If toggling is not allowed, set disabled state on trigger
          if (!this.allowToggle) {
            target.setAttribute('aria-disabled', 'true');
          }
          this.hideShowPanel(target, target, false);
          this.addRemoveOpenPanels(target.getAttribute('aria-controls'), true);
        } else if (this.allowToggle && isExpanded) {
          this.hideShowPanel(target, target, true);
          this.addRemoveOpenPanels(target.getAttribute('aria-controls'), false);
        }
      }
    }
  }, {
    key: "handleKeydown",
    value: function handleKeydown(e) {
      var triggers = Array.prototype.slice.call(this.tabs);
      var target = e.target;
      var key = e.key;
      if (key.match(/Down|ArrowDown|Up|ArrowUp/)) {
        // Up, Down arrow keyboard operations
        var negativeOne = -1;
        var index = triggers.indexOf(target);
        var direction = key.match(/ArrowDown|Down/) ? 1 : negativeOne;
        var length = triggers.length;
        var newIndex = (index + length + direction) % length;
        triggers[newIndex].focus();
        e.preventDefault();
      } else if (key.match(/End|Home/)) {
        // End, Home keyboard operations
        switch (key) {
          // Go to first tab
          case 'Home':
            triggers[0].focus();
            break;
          // Go to last tab
          case 'End':
            triggers[triggers.length - 1].focus();
            break;
          default:
        }
        e.preventDefault();
      } else if (key.match(/Spacebar|Space|Enter/)) {
        // Spacebar, Enter keyboard operations
        this.setActiveTab(target);
        this.addRemoveOpenPanels(target.getAttribute('aria-controls'), true);
      }
    }

    /*	The panes are set to 'panel' when the viewport is desktop
    	and 'region' when the viewport is mobile.
    	This is because the vertical tabs are displayed as an Accordion on mobile.
    */
  }, {
    key: "setAriaRoles",
    value: function setAriaRoles(roleValue) {
      this.tabsGroup.querySelectorAll('[data-tab-toggle-panel]').forEach(function (accordionBtn) {
        accordionBtn.setAttribute('role', roleValue);
      });
    }
  }, {
    key: "adjustForViewport",
    value: function adjustForViewport(pageLoad) {
      var _this2 = this;
      var screenMaxWidthChange = 992;

      // Desktop to desktop resize - do nothing
      if (window.innerWidth > screenMaxWidthChange && !this.isMobile) {
        return;
      }

      // Mobile to desktop resize - open the Tab based on the last opened Accordion and set aria roles to panel
      if (window.innerWidth > screenMaxWidthChange && this.isMobile) {
        this.isMobile = false;
        this.setAriaRoles('panel');
        if (pageLoad) {
          return;
        }

        // Open the first tab if no Accordion was open when the viewport was resized
        if (this.openPanels.length === 0) {
          this.setActiveTab(this.firstTab);
          this.addRemoveOpenPanels(this.firstTab.getAttribute('aria-controls'), true);
          return;
        }

        //Close all but the last opened Accordion
        this.tabPanels.forEach(function (panel) {
          var tab = _this2.tabNav.querySelector('[aria-controls="' + panel.id + '"]');
          if (panel.id !== _this2.openPanels[_this2.openPanels.length - 1]) {
            panel.hidden = true;
            tab.setAttribute('aria-selected', 'false');
            tab.tabIndex = -1;
          } else {
            tab.setAttribute('aria-selected', 'true');
            tab.tabindex = 0;
          }
        });

        // Trim the open panels array to only the last opened Accordion
        var thereCanOnlyBeOne = 2;
        if (this.openPanels.length >= thereCanOnlyBeOne) {
          this.openPanels = this.openPanels.splice(this.openPanels.length - 1, 1);
        }
        return;
      }

      //Desktop to mobile resize - open the Accordion based on the last opened Tab and set aria roles to region
      if (!this.isMobile) {
        this.isMobile = true;
        this.setAriaRoles('region');
        this.tabAccordionTriggers.forEach(function (aTrigger) {
          var isExpanded = aTrigger.getAttribute('aria-controls') === _this2.openPanels[_this2.openPanels.length - 1];
          aTrigger.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
        });
      }
    }
  }, {
    key: "init",
    value: function init() {
      var _this3 = this;
      this.tabNav = this.tabsGroup.querySelector('[role=tablist]');
      this.tabs = Array.from(this.tabNav.querySelectorAll('[role*=tab]'));
      for (var i = 0; i < this.tabs.length; i += 1) {
        var tab = this.tabs[i];
        var tabPanel = document.getElementById(tab.getAttribute('aria-controls'));
        this.tabPanels.push(tabPanel);
        tab.addEventListener('keydown', function (e) {
          return _this3.handleKeydown(e);
        });
        tab.addEventListener('click', function (e) {
          _this3.setActiveTab(e.target);
          _this3.addRemoveOpenPanels(e.target.getAttribute('aria-controls'), true);
        });
        if (!this.firstTab) {
          this.firstTab = tab;
        }
        this.lastTab = tab;
      }
      this.allowMultiple = this.tabsGroup.hasAttribute('data-allow-multiple');
      this.allowToggle = this.allowMultiple ? this.allowMultiple : this.tabsGroup.hasAttribute('data-allow-toggle');
      this.tabAccordionTriggers = this.tabsGroup.querySelectorAll('[data-tab-toggle-trigger]');
      this.tabsGroup.addEventListener('click', function (e) {
        return _this3.handleTargetClick(e);
      });
      this.adjustForViewport(true);
    }
  }]);
}();
var VertTabsController = /*#__PURE__*/function () {
  function VertTabsController() {
    _classCallCheck(this, VertTabsController);
  }
  return _createClass(VertTabsController, null, [{
    key: "init",
    value: function init(tabGroup) {
      if (tabGroup) {
        var vertTabs = new VertTabsClass(tabGroup);
        vertTabs.init();
        window.addEventListener('resize', vertTabs.debounce(function () {
          vertTabs.adjustForViewport(false);
        }, this.windowResizeDelay));
      }
    }
  }]);
}();
/* istanbul ignore next */
if (typeof exports !== 'undefined') {
  module.exports = VertTabsController;
}
var AccordionMinimal = /*#__PURE__*/function () {
  function AccordionMinimal(accordionGroup) {
    _classCallCheck(this, AccordionMinimal);
    this.accordionGroup = accordionGroup;
    this.accordionTriggers = null;
  }
  return _createClass(AccordionMinimal, [{
    key: "handleTargetClick",
    value: function handleTargetClick(event) {
      var target = event.target.closest('[data-toggle-trigger]');
      if (!target) {
        return;
      }
      if (target.hasAttribute('data-toggle-trigger')) {
        // Check if the current toggle is expanded
        var isExpanded = target.getAttribute('aria-expanded') === 'true';
        var active = this.accordionGroup.querySelector('[aria-expanded="true"]');

        // Without allowMultiple, close the open accordion
        if (!this.allowMultiple && active && active !== target) {
          // Set the expanded state on the triggering element
          active.setAttribute('aria-expanded', 'false');
          if (target.hasAttribute('aria-controls')) {
            this.accordionGroup.querySelector('[id="' + target.getAttribute('aria-controls') + '"]').hidden = true;
          }

          // When toggling is not allowed, clean up disabled state
          if (!this.allowToggle) {
            active.removeAttribute('aria-disabled');
          }
        }
        if (!isExpanded) {
          // Set the expanded state on the triggering element
          target.setAttribute('aria-expanded', 'true');
          if (target.hasAttribute('aria-controls')) {
            this.accordionGroup.querySelector('[id="' + target.getAttribute('aria-controls') + '"]').hidden = false;
          }

          // If toggling is not allowed, set disabled state on trigger
          if (!this.allowToggle) {
            target.setAttribute('aria-disabled', 'true');
          }
        } else if (this.allowToggle && isExpanded) {
          // Set the expanded state on the triggering element
          target.setAttribute('aria-expanded', 'false');
          if (target.hasAttribute('aria-controls')) {
            this.accordionGroup.querySelector('[id="' + target.getAttribute('aria-controls') + '"]').hidden = true;
          }
        }
      }
    }
  }, {
    key: "handleTargetKeydown",
    value: function handleTargetKeydown(event) {
      // Create the array of toggle elements for the accordion group
      var triggers = Array.prototype.slice.call(this.accordionTriggers);
      var target = event.target;
      var key = event.key;

      // Is this coming from an accordion header?
      if (!target.hasAttribute('data-toggle-trigger')) {
        return;
      }
      if (key.match(/Down|ArrowDown|Up|ArrowUp/)) {
        // Up/Down arrow keyboard operations
        var negativeOne = -1;
        var index = triggers.indexOf(target);
        var direction = key.match(/ArrowDown|Down/) ? 1 : negativeOne;
        var length = triggers.length;
        var newIndex = (index + length + direction) % length;
        triggers[newIndex].focus();
        event.preventDefault();
      } else if (key.match(/End|Home/)) {
        // End, Home keyboard operations
        switch (key) {
          // Go to first accordion
          case 'Home':
            triggers[0].focus();
            break;
          // Go to last accordion
          case 'End':
            triggers[triggers.length - 1].focus();
            break;
          default:
        }
        event.preventDefault();
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      var _this4 = this;
      // These are used to style the accordion when one of the buttons has focus
      this.accordionGroup.querySelectorAll('[data-toggle-trigger]').forEach(function (trigger) {
        trigger.addEventListener('focus', function () {
          _this4.accordionGroup.classList.add('focus');
        });
        trigger.addEventListener('blur', function () {
          _this4.accordionGroup.classList.remove('focus');
        });
      });
    }
  }, {
    key: "init",
    value: function init() {
      var _this5 = this;
      this.accordionTriggers = this.accordionGroup.querySelectorAll('[data-toggle-trigger]');
      if (!this.accordionTriggers.length) {
        return;
      }

      // Allow for multiple accordion sections to be expanded at the same time
      this.allowMultiple = this.accordionGroup.hasAttribute('data-allow-multiple');
      this.allowToggle = this.allowMultiple ? this.allowMultiple : this.accordionGroup.hasAttribute('data-allow-toggle');
      this.accordionGroup.addEventListener('click', function (e) {
        return _this5.handleTargetClick(e);
      });

      // Bind keyboard behaviors on the main accordion container
      this.accordionGroup.addEventListener('keydown', function (e) {
        return _this5.handleTargetKeydown(e);
      });
      this.handleFocus();
    }
  }]);
}();
var AccordionController = /*#__PURE__*/function () {
  function AccordionController() {
    _classCallCheck(this, AccordionController);
  }
  return _createClass(AccordionController, null, [{
    key: "init",
    value: function init(accordionGroup) {
      if (accordionGroup) {
        var accordion = new AccordionMinimal(accordionGroup);
        accordion.init();
      }
    }
  }]);
}();
if (typeof exports !== 'undefined') {
  module.exports = AccordionController;
}
/* global SnhuStorageUtil */

/**
 * AlertController bundles together static methods used to regulate alert objects in document
 */
var AlertController = /*#__PURE__*/function () {
  /**
   * @param {class} storageUtil - an instance of SnhuStorageUtil
   * @param {NodeList} alerts - list of alert nodes/objects
   */
  function AlertController(storageUtil, alerts) {
    _classCallCheck(this, AlertController);
    this.alerts = alerts;
    this.storageUtil = storageUtil || new SnhuStorageUtil();
    this.localStorageKey = 'alerts.dismissedIds';
    this.dismissedIdsValue = this.cleanDismissedIds();
  }

  /**
   * Returns a list of dismissible buttons for alert
   * @return {NodeList} list of all dismissible buttons in document.
   */
  /* eslint-disable class-methods-use-this */
  return _createClass(AlertController, [{
    key: "getDismissibles",
    value: function getDismissibles() {
      return document.querySelectorAll('.alert .alert-dismissible');
    }
    /* eslint-enable class-methods-use-this */

    /**
     * @returns  {Object} of (alertId, dateDismissed)
     */
  }, {
    key: "cleanDismissedIds",
    value: function cleanDismissedIds() {
      var idsObj = this.storageUtil.getJSONItem(this.localStorageKey);
      if (!idsObj || Object.keys(idsObj).length === 0) {
        return {};
      }

      /**remove any expired ids*/
      Object.keys(idsObj).forEach(function (key) {
        var dismissedDate = idsObj[key];
        /*eslint-disable-next-line no-magic-numbers*/
        var twentyFourHours = 24 * 60 * 60 * 1000;
        if (dismissedDate && Date.now() - dismissedDate > twentyFourHours) {
          delete idsObj[key];
        }
      });

      //we're going to update the local storage with the new idsObj so it only contains current, valid ids
      this.storageUtil.setJSONItem(this.localStorageKey, idsObj);
      return idsObj;
    }

    /**
     * Returns a list of alerts in the document
     * @return {NodeList}
     */
  }, {
    key: "showAlert",
    value:
    /**
     * Used on page load to show alerts that have not been dismissed in the session.
     * On load - alert have the 'dismissed' class
     * @param {Node} alert
     */

    function showAlert(alert) {
      if (!this.dismissedIdsValue[alert.id]) {
        alert.classList.remove('dismissed');
      }
    }

    /**
     * Closes the alert by adding the 'dismissed' class.
     * @param {Node} alert
     */
  }, {
    key: "closeAlert",
    value: function closeAlert(alert) {
      alert.classList.add('dismissed');
      this.dismissedIdsValue[alert.id] = Date.now();
      this.storageUtil.setJSONItem(this.localStorageKey, this.dismissedIdsValue);
    }
  }, {
    key: "init",
    value: function init() {
      var _this6 = this;
      this.alerts.forEach(function (alert) {
        _this6.showAlert(alert);
      });
      var dismissibles = this.getDismissibles();
      dismissibles.forEach(function (dismissible) {
        var parentAlert = dismissible.closest('.alert');
        if (!parentAlert.classList.contains('dismissed')) {
          dismissible.addEventListener('click', function () {
            _this6.closeAlert(parentAlert);
          });
        }
      });
    }
  }], [{
    key: "getAlerts",
    value: function getAlerts() {
      return document.querySelectorAll('.alert');
    }
  }]);
}(); // export as a module for unit testing
if (typeof exports !== 'undefined') {
  module.exports = AlertController;
}

// Initialize and run in IIFE
(function () {
  window.addEventListener('load', function () {
    var alerts = AlertController.getAlerts();
    if (alerts.length === 0) {
      return;
    }
    var alertController = new AlertController(new SnhuStorageUtil(), alerts);
    alertController.init();
  });
})();
// Used to assign keyboard commands 'spacebar' and 'enter' for all items with role="button"
var ButtonController = /*#__PURE__*/function () {
  function ButtonController() {
    _classCallCheck(this, ButtonController);
  }
  return _createClass(ButtonController, null, [{
    key: "allAriaButtons",
    get: function get() {
      return document.querySelectorAll('[role*="button"]');
    }
  }, {
    key: "addKeyListeners",
    value: function addKeyListeners() {
      var buttons = ButtonController.allAriaButtons;
      buttons.forEach(function (btn) {
        // Get the href of the btn if there is one
        var href = btn.href ? btn.href : '';
        btn.addEventListener('keydown', function (e) {
          var validKeys = ['Spacebar', 'Space', ' ', 'Enter'];
          if (validKeys.indexOf(e.key) >= 0 || validKeys.indexOf(e.code) >= 0) {
            e.preventDefault(); // Prevent the spacebar from scrolling down the page for A11y

            // Check if the href has a # at the start
            var hrefItem = href.match(/#[a-z-]+/gi);
            if (hrefItem) {
              // Scroll and focus on the anchor element
              // This prevents the hash from being added to the URL which causes a 404 on the catalog
              hrefItem = document.getElementById(hrefItem[0].substring(1));
              window.scrollTo(0, hrefItem.offsetTop);
              hrefItem.focus();
            } else {
              btn.click();
            }
          }
        });
      });
    }
  }]);
}(); // Initialize and run in IIFE
(function () {
  window.addEventListener('load', function () {
    ButtonController.addKeyListeners();
  });
})();
// NOTE: Gulp adds this file to /components/Legacy, changes should be applied to the file found in /components/Foundation

/*eslint no-use-before-define: ["error", { "functions": false }]*/

var ModalController = function ModalController() {
  function _openModal(mc) {
    // Markup changes
    mc.backdrop.classList.add('show');
    mc.modal.classList.add('show');
    mc.modal.tabIndex = "0";
    document.querySelector('body').classList.add('modal-open');

    // Set focus to first focusable item, the modal close button
    mc.modalCloseBtn.focus();

    // Add event listeners, only present when modal is open

    // Trap focus in modal elements
    mc.modalCloseBtn.addEventListener('keydown', function (e) {
      _modalCloseBtnKeyHandler(e, mc);
    });
    mc.lastFocusable.addEventListener('keydown', function (e) {
      _lastFocusableTabHandler(e, mc.modalCloseBtn);
    });

    // Escape Key event
    document.addEventListener('keydown', function (e) {
      _escapeKeyCloseModal(e, mc);
    });

    // Modal off click event
    document.addEventListener('click', function (e) {
      _offClickCloseModal(e, mc);
    });

    // Modal close button click event
    mc.modalCloseBtn.addEventListener('click', function () {
      _closeModal(mc);
    });
  }
  function _closeModal(mc) {
    // Markup changes
    mc.backdrop.classList.remove('show');
    mc.modal.classList.remove('show');
    mc.modal.tabIndex = "-1";
    document.querySelector('body').classList.remove('modal-open');

    // Remove event listeners, only present when modal is open
    mc.modalCloseBtn.removeEventListener('keydown', function (e) {
      _modalCloseBtnKeyHandler(e, mc);
    });
    mc.lastFocusable.removeEventListener('keydown', function (e) {
      _lastFocusableTabHandler(e, mc.modalCloseBtn);
    });

    // Escape Key event
    document.removeEventListener('keydown', function (e) {
      _escapeKeyCloseModal(e, mc);
    });

    // Modal off click event
    document.removeEventListener('click', function (e) {
      _offClickCloseModal(e, mc);
    });

    // Modal close button click event
    mc.modalCloseBtn.removeEventListener('click', function () {
      _closeModal(mc);
    });
  }
  function _escapeKeyCloseModal(e, mc) {
    var key = e.key;
    if (key === 'Escape' || key === 'Esc') {
      _closeModal(mc);
    }
  }
  function _offClickCloseModal(e, mc) {
    var notFound = -1;
    if ((!e.target.href || e.target.href.indexOf(mc.modal.id) === notFound) && e.target.closest('.modal-content') === null) {
      _closeModal(mc);
    }
  }
  function _modalCloseBtnKeyHandler(e, mc) {
    var key = e.key;
    var tabKey = 'Tab';
    var enterKey = 'Enter';

    // Give last element focus if shift + tab from first focusable element
    if (key === tabKey && e.shiftKey) {
      e.preventDefault();
      mc.lastFocusable.focus();
    } else if (key === enterKey) {
      _closeModal(mc);
    }
  }
  function _lastFocusableTabHandler(e, firstFocusable) {
    var key = e.key;
    var tabKey = 'Tab';

    // If tab is pressed set focus to first focusable item
    if (key === tabKey && !e.shiftKey) {
      e.preventDefault();
      firstFocusable.focus();
    }
  }
  function _init(modal) {
    var mc = new Object();
    mc.modal = modal;
    mc.backdrop = modal.nextElementSibling;
    var focusables = document.querySelectorAll('#' + mc.modal.id + ' [href], #' + mc.modal.id + ' :enabled');
    mc.modalCloseBtn = focusables[0];
    mc.lastFocusable = focusables[focusables.length - 1];
    var buttons = document.querySelectorAll('[href="#' + mc.modal.id + '"]');
    if (buttons.length > 0) {
      buttons.forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          _openModal(mc);
        });
      });
    }
  }
  return {
    init: _init,
    openModal: _openModal,
    closeModal: _closeModal,
    escapeKeyCloseModal: _escapeKeyCloseModal,
    offClickCloseModal: _offClickCloseModal,
    modalCloseBtnKeyHandler: _modalCloseBtnKeyHandler,
    lastFocusableTabHandler: _lastFocusableTabHandler
  };
};
if (typeof exports !== 'undefined') {
  module.exports = ModalController;
}
var VideoListener = /*#__PURE__*/function () {
  function VideoListener(scope) {
    _classCallCheck(this, VideoListener);
    // Bind the 'this' keyword in the loadVideo method to the current instance of VideoListener
    this.loadVideo = this.loadVideo.bind(this);
    // Set the scope property to the provided scope, or to the whole document if no scope is provided
    this.scope = scope || document;
  }
  return _createClass(VideoListener, [{
    key: "loadVideo",
    value: function loadVideo() {
      // Find the first element with the class 'ytiframe' within the scope
      var ytiframe = this.scope.querySelector(".ytiframe");

      // If no such element is found, exit the function
      if (!ytiframe) {
        return;
      }

      // Get the 'data-src' attribute of the ytiframe element
      var ytiframeDataSrc = ytiframe.getAttribute("data-src");

      // If the 'data-src' attribute is not set, exit the function
      if (!ytiframeDataSrc) {
        return;
      }

      // Set the 'src' attribute of the ytiframe element to the value of the 'data-src' attribute
      ytiframe.src = ytiframeDataSrc;

      // Set the opacity of the ytiframe element to 1, making it fully visible
      ytiframe.style.opacity = 1;
    }
  }]);
}(); // When the page has finished loading
window.addEventListener("load", function () {
  // Find all elements with the class 'ytplaceholder'
  var ytplaceholders = document.querySelectorAll(".ytplaceholder");

  // If no such elements are found, exit the function
  if (!ytplaceholders) {
    return;
  }

  // For each ytplaceholder element
  ytplaceholders.forEach(function (ytplaceholder) {
    // Create a new VideoListener for the ytplaceholder element
    var videoListener = new VideoListener(ytplaceholder);
    // Call the loadVideo method of the VideoListener
    videoListener.loadVideo();
  });
});
var HorizontalScrollCarousel = /*#__PURE__*/function () {
  function HorizontalScrollCarousel(carousel) {
    _classCallCheck(this, HorizontalScrollCarousel);
    this.carousel = carousel;
    this.responsive = [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 575,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 375,
      settings: {
        slidesToShow: 1
      }
    }];
    this.slidesContainer = carousel.querySelector("[data-target='slidesContainer']");
    this.slides = carousel.querySelectorAll("[data-target='slide']");
    this.totalSlides = this.slides.length;
    this.totaSlidesMinusOne = this.totalSlides - 1;
    this.slidesToShow = this.calculateSlidesToShow();
    this.numberOfSwipes = this.totalSlides - this.slidesToShow;
    this.nextBtn = carousel.querySelector("[data-action='slideRight']");
    this.prevBtn = carousel.querySelector("[data-action='slideLeft']");
    this.nextBtnContainer = carousel.querySelector(".carousel-arrows-container-right");
    this.prevBtnContainer = carousel.querySelector(".carousel-arrows-container-left");
    this.leftMostSlideIndex = 0;
    this.totalSlideWidth = 0;
    this.touchStartX = 0;
    this.touchEndX = 0;
  }
  return _createClass(HorizontalScrollCarousel, [{
    key: "initHorizontalScrollCarousel",
    value: function initHorizontalScrollCarousel() {
      var _this7 = this;
      /**
             * Setup previous/next button behaviors
             * on mobile
             */
      this.slidesContainer.addEventListener("touchstart", function (e) {
        _this7.touchStartX = e.changedTouches[0].screenX;
      }, false);
      this.slidesContainer.addEventListener("touchend", function (e) {
        _this7.touchEndX = e.changedTouches[0].screenX;
        _this7.handleSwipe();
      }, false);

      /**
             * Set up previous/next button behaviors
             * on desktop
             */
      this.prevBtn.addEventListener("click", function (e) {
        e.preventDefault();
        _this7.prevSlide();
      });
      this.nextBtn.addEventListener("click", function (e) {
        e.preventDefault();
        _this7.nextSlide();
      });
      this.calculatTotalSlideWidth();
      this.addMarginToLastSlide();
      this.hideNonVisibleSlides();
      this.toggleBtnVisibility();
      window.addEventListener("resize", function () {
        _this7.slidesToShow = _this7.calculateSlidesToShow();
        _this7.toggleBtnVisibility();
        _this7.hideNonVisibleSlides();
        _this7.calculatTotalSlideWidth();
      });
    }

    /**
        * Handle left arrow click
        */
  }, {
    key: "prevSlide",
    value: function prevSlide() {
      if (this.leftMostSlideIndex > 0) {
        this.goToSlide(this.leftMostSlideIndex - 1);
        this.toggleBtnVisibility();
      }
    }

    /**
        * Handle right arrow click
        */
  }, {
    key: "nextSlide",
    value: function nextSlide() {
      if (this.leftMostSlideIndex < this.totaSlidesMinusOne) {
        this.goToSlide(this.leftMostSlideIndex + 1);
        this.toggleBtnVisibility();
      }
    }

    /**
        * Handle swipe gestures
        */
  }, {
    key: "handleSwipe",
    value: function handleSwipe() {
      if (this.touchEndX < this.touchStartX) {
        this.nextSlide();
      } else if (this.touchEndX > this.touchStartX) {
        this.prevSlide();
      }
    }

    /**
     * Add margin right that's the equivalent to the
     * total slide width so users can slide past the
     * last slide.
     */
  }, {
    key: "addMarginToLastSlide",
    value: function addMarginToLastSlide() {
      // Get the last slide
      var lastSlide = this.slides[this.totaSlidesMinusOne];

      // Add a margin-right to the last slide
      var halfSlideWidth = 2;
      lastSlide.style.marginRight = "".concat(this.totalSlideWidth / halfSlideWidth, "px");
    }

    /**
        * Toggle the visibility of the previous and next buttons
        */
  }, {
    key: "toggleBtnVisibility",
    value: function toggleBtnVisibility() {
      var toggleVisibility = function toggleVisibility(container, btn, condition) {
        container.classList.toggle("d-none", condition);
        container.classList.toggle("d-lg-block", !condition);
        btn.toggleAttribute("aria-disabled", condition);
      };
      if (this.slidesToShow === 1) {
        this.prevBtnContainer.classList.add("d-none", "d-lg-block");
        this.prevBtn.setAttribute("aria-disabled", "true");
        this.nextBtnContainer.classList.add("d-none", "d-lg-block");
        this.nextBtn.setAttribute("aria-disabled", "true");
        return;
      }
      var isAtStart = this.leftMostSlideIndex === 0;
      var isAtEnd = this.leftMostSlideIndex === this.totalSlides - this.slidesToShow;
      toggleVisibility(this.prevBtnContainer, this.prevBtn, isAtStart);
      toggleVisibility(this.nextBtnContainer, this.nextBtn, isAtEnd);
    }

    /**
        * @param {any} nextLeftMostSlideIndex next slide in the index
        */
  }, {
    key: "goToSlide",
    value: function goToSlide(nextLeftMostSlideIndex) {
      if (!(nextLeftMostSlideIndex <= this.numberOfSwipes)) {
        return;
      }
      /**
       * The scroll amount is the total width of the slides
       * multiplied by the index of the next left-most slide.
       */
      var scrollAmount = this.totalSlideWidth * nextLeftMostSlideIndex;

      /**
       * Smoothly scroll to the requested slide
       */
      this.slidesContainer.scroll({
        left: scrollAmount,
        behavior: "smooth"
      });

      /**
       * Update the record of which slide is the left most slide.
       */
      this.leftMostSlideIndex = nextLeftMostSlideIndex;

      /**
       * Hide non-visible slides and check if the
       * previous/next buttons should be hidden
       */
      this.hideNonVisibleSlides();
    }

    /**
        * Calculate the total width of a slide so that
        * the scroll amount can be calculated
        */
  }, {
    key: "calculatTotalSlideWidth",
    value: function calculatTotalSlideWidth() {
      var slide = document.querySelector("[data-target='slide']");
      if (!slide) {
        return;
      }
      var slideStyle = slide.currentStyle || window.getComputedStyle(slide);
      var slideWidth = Number(slideStyle.width.match(/\d+/g)[0]);
      var slideMarginRight = Number(slideStyle.marginRight.match(/\d+/g)[0]);
      this.totalSlideWidth = slideWidth + slideMarginRight;
    }

    /**
     * Look at the viewport width and determine how many slides to show
     * @returns {number} number of slides to show based on the viewport width
     */
  }, {
    key: "calculateSlidesToShow",
    value: function calculateSlidesToShow() {
      var viewportWidth = window.innerWidth;
      var responsiveBreakpoint = this.responsive.find(function (responsiveBreakpoint) {
        return viewportWidth >= responsiveBreakpoint.breakpoint;
      }) || this.responsive[this.responsive.length - 1];
      return responsiveBreakpoint.settings.slidesToShow;
    }

    /**
        * Fully hide non-visible slides by adding aria-hidden="true"
        * and tabindex="-1" when they go out of view
        */
  }, {
    key: "hideNonVisibleSlides",
    value: function hideNonVisibleSlides() {
      var _this8 = this;
      var showSlide = function showSlide(slide, focusableElements) {
        slide.removeAttribute("aria-hidden");
        slide.classList.add("active");
        focusableElements.forEach(function (focusableElement) {
          focusableElement.removeAttribute("tabindex");
        });
      };
      this.slides.forEach(function (slide) {
        slide.setAttribute("aria-hidden", true);
        slide.classList.remove("active");
        var focusableElements = slide.querySelectorAll('a, button, [tabindex="0"]');
        focusableElements.forEach(function (focusableElement) {
          focusableElement.setAttribute("tabindex", -1);
        });
        var start = _this8.leftMostSlideIndex === 0 ? 0 : _this8.leftMostSlideIndex;
        var end = start + _this8.slidesToShow;
        for (var i = start; i < end; i++) {
          showSlide(_this8.slides[i], focusableElements);
        }
      });
    }
  }]);
}();
var HorizontalScrollCarouselController = /*#__PURE__*/function () {
  function HorizontalScrollCarouselController() {
    _classCallCheck(this, HorizontalScrollCarouselController);
  }
  return _createClass(HorizontalScrollCarouselController, null, [{
    key: "init",
    value: function init(carousel) {
      if (carousel) {
        var horizontalScroll = new HorizontalScrollCarousel(carousel);
        horizontalScroll.initHorizontalScrollCarousel();
      }
    }
  }]);
}();
if (typeof exports !== "undefined") {
  module.exports = HorizontalScrollCarouselController;
  module.exports = HorizontalScrollCarousel;
}

/*
 * Generic cookie utility to get, set, read values (for multi value cookies), update values (for multi value cookies)
 * This is just the start of this helper - should be expanded on as needed.
 */
var SnhuCookieUtil = /*#__PURE__*/function () {
  /* Constructor */
  function SnhuCookieUtil(name) {
    _classCallCheck(this, SnhuCookieUtil);
    this.name = name;
    this.domain = "snhu.edu";
    this.cookieValues = {};
  }

  /* Get cookie values for string cookie with multilple values
   * Will return a JSON object with the name of the cookie as the key for single value cookies
   * Currently applies to:
   * Thank You Cookie
   * Eccommerce Cookie (not using this class)
   * Update after/during story 10208 - Migrate Cookie and JS Code to use JSON format */
  return _createClass(SnhuCookieUtil, [{
    key: "getCookieValues",
    value: function getCookieValues() {
      var cookieContents = this.getCookie();
      var jsonCookieValues = {};
      var _cookieValues = cookieContents.split(',');
      if (_cookieValues.length <= 1) {
        jsonCookieValues[this.name] = cookieContents;
      } else {
        _cookieValues.forEach(function (cookieString) {
          var cookieStringSplit = cookieString.split(':');
          jsonCookieValues[cookieStringSplit[0]] = cookieStringSplit[1];
        });
      }
      this.cookieValues = jsonCookieValues;
    }

    /* Specific value from the cookie
    * Gets a cookie value after the cookie has been converted to JSON object
    * cookieValues - JSON
    * @param {string} cookieValue - name of the key of value requested
    * returns string */
  }, {
    key: "getCookieValue",
    value: function getCookieValue(cookieValue) {
      if (Object.keys(this.cookieValues).includes(cookieValue)) {
        return this.cookieValues[cookieValue];
      }
      return '';
    }

    /* Returns a cookie's value with the given name, if not found returns empty string. */
  }, {
    key: "getCookie",
    value: function getCookie() {
      var cookieName = this.name + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var splitCookie = decodedCookie.split(';');
      for (var i = 0; i < splitCookie.length; i++) {
        var c = splitCookie[i];
        c = c.trim();
        if (c.indexOf(cookieName) === 0) {
          return c.substring(cookieName.indexOf('=') + 1);
        }
      }
      return '';
    }

    /* Sets a cookie.
     * @param {string} cookieValue  - the string value of the cookie to be set
     * @param {number} expiration - number of days to add to current date-time
     */
  }, {
    key: "setCookie",
    value: function setCookie(cookieValue, expiration) {
      var domainString = this.domain === "" ? this.domain : "domain=" + this.domain + ";";
      if (expiration === undefined) {
        document.cookie = "".concat(this.name, "=").concat(encodeURIComponent(cookieValue), ";path=/;").concat(domainString);
      } else {
        var date = new Date();
        date.setDate(date.getDate() + expiration);
        var expires = "expires=" + date.toUTCString();
        document.cookie = "".concat(this.name, "=").concat(encodeURIComponent(cookieValue), ";").concat(expires, ";path=/;").concat(domainString);
      }
    }
  }]);
}();
if (typeof exports !== "undefined") {
  module.exports = SnhuCookieUtil;
}
var SnhuFetchUtil = /*#__PURE__*/function () {
  function SnhuFetchUtil(customRequestSettings) {
    _classCallCheck(this, SnhuFetchUtil);
    this.requestSettings = _objectSpread({
      mode: "cors",
      // no-cors, *cors, same-origin
      cache: "no-cache",
      // *default, no-cache, reload, force-cache, only-if-cached
      defaultTimeout: 10000,
      // set default fetch timeout to 10 seconds
      headers: {
        "X-Requested-With": "XMLHttpRequest"
      }
    }, customRequestSettings);
  }

  // helper function/s

  // Response handler/parser
  return _createClass(SnhuFetchUtil, [{
    key: "get",
    value: function get(url) {
      var requestOptions = _objectSpread(_objectSpread({}, this.requestSettings), {}, {
        method: "GET"
      });
      return SnhuFetchUtil.timeoutPromise(this.requestSettings.defaultTimeout, fetch(url, requestOptions).then(SnhuFetchUtil.handleResponse));
    }
  }, {
    key: "post",
    value: function post(url, body) {
      var requestOptions = _objectSpread(_objectSpread({}, this.requestSettings), {}, {
        method: "POST",
        body: body
      });
      return SnhuFetchUtil.timeoutPromise(this.requestSettings.defaultTimeout, fetch(url, requestOptions).then(SnhuFetchUtil.handleResponse));
    }
  }, {
    key: "put",
    value: function put(url, body) {
      var requestOptions = _objectSpread(_objectSpread({}, this.requestSettings), {}, {
        method: "PUT",
        body: body
      });
      return SnhuFetchUtil.timeoutPromise(this.requestSettings.defaultTimeout, fetch(url, requestOptions).then(SnhuFetchUtil.handleResponse));
    }
  }], [{
    key: "handleResponse",
    value: function handleResponse(response) {
      return response.text().then(function (text) {
        // If response is outside of 200 block reject the promise with the response status
        if (!response.ok) {
          return Promise.reject({
            status: response.status
          });
        }

        // If the response is null reject the promise with a no response from server message
        if (!text) {
          return Promise.reject("No response from server.");
        }
        var data = {};
        // Try parsing the response if it's successful
        try {
          //set data to the parsed text
          data = JSON.parse(text);
        } catch (error) {
          // If the text can't be parsed, the response was invalid from the server, reject the promise
          return Promise.reject("Invalid response from server.");
        }
        return data;
      });
    }

    // Timeout promise (removes timeout if promise was resolved or rejected internally)
  }, {
    key: "timeoutPromise",
    value: function timeoutPromise(miliseconds, promise) {
      return new Promise(function (resolve, reject) {
        var timeoutId = setTimeout(function () {
          reject(new Error("Fetch default timeout (".concat(miliseconds, " ms) reached.")));
        }, miliseconds);
        promise.then(function (res) {
          clearTimeout(timeoutId);
          resolve(res);
        }, function (error) {
          clearTimeout(timeoutId);
          reject(error);
        });
      });
    }
  }]);
}();
if (typeof exports !== "undefined") {
  module.exports = SnhuFetchUtil;
}
var SnhuStorageUtil = /*#__PURE__*/function () {
  /*
   * Storage should be 'session' or 'local'; default localStorage
   @param {string} storageType - 'session' or 'local'
   */
  function SnhuStorageUtil(storageType) {
    _classCallCheck(this, SnhuStorageUtil);
    if (storageType === 'session') {
      this.storage = window.sessionStorage;
    } else {
      this.storage = window.localStorage;
    }
  }
  /**
   * @param {any} itemName - storage key
   * @param {any} value
   * @returns
   */
  return _createClass(SnhuStorageUtil, [{
    key: "setItem",
    value: function setItem(itemName, value) {
      try {
        this.storage.setItem(itemName, value);
      } catch (ex) {
        return false;
      }
      return true;
    }
    /**
     * @param {string} itemName - storage key
     * @returns {string} - value
     */
  }, {
    key: "getItem",
    value: function getItem(itemName) {
      try {
        return this.storage.getItem(itemName);
      } catch (ex) {
        return false;
      }
    }
    /**
     * @param {string} itemName  - storage key
     * @returns {boolean}
     */
  }, {
    key: "removeItem",
    value: function removeItem(itemName) {
      try {
        this.storage.removeItem(itemName);
        return true;
      } catch (ex) {
        return false;
      }
    }

    /**
     * CAUTION! This will delete ALL storage for this storage type
     * @returns {boolean}
     */
  }, {
    key: "clear",
    value: function clear() {
      try {
        this.storage.clear();
        return true;
      } catch (ex) {
        return false;
      }
    }
    /**
     *
     * @param {number} indexNumber
     * @returns {string} - name of key
     */
  }, {
    key: "key",
    value: function key(indexNumber) {
      try {
        return this.storage.key(indexNumber);
      } catch (ex) {
        return false;
      }
    }

    //SNHU SPECIFIC ITEMS BELOW

    /**
     * @param {string} itemName - key
     * @param {JSON} valueAsJsonObject - value
     * @returns
     */
  }, {
    key: "setJSONItem",
    value: function setJSONItem(itemName, valueAsJsonObject) {
      var stringJSON = JSON.stringify(valueAsJsonObject);
      return this.setItem(itemName, stringJSON);
    }

    /**
     * @param {string} itemName - key
     * @returns {JSON} - value
     */
  }, {
    key: "getJSONItem",
    value: function getJSONItem(itemName) {
      var stringJSON = this.getItem(itemName);
      return stringJSON === false ? {} : JSON.parse(stringJSON);
    }
  }]);
}();
if (typeof exports !== 'undefined') {
  module.exports = SnhuStorageUtil;
}

/**
* Generic Tracking Controller class that can be applied to instances like Google cross-form or paid search.
*/
var trackingController = /*#__PURE__*/function () {
  /**
  * Constructor for trackingController
  * @param {location} address
  * @param {array} paramNames
  * @param {String} cookieName
  * @param {int} expiration
  * @param {String} domain
  */
  function trackingController(address, paramNames, cookieName, expiration, domain) {
    _classCallCheck(this, trackingController);
    this.address = decodeURI(address);
    this.reqParams = paramNames;
    this.cookieName = cookieName;
    this.expiration = expiration;
    this.domain = domain;
  }

  /**
   * Converts an array to object with properties (assumes each two items are key value pairs)
   * @param {array} params
   * @param {int} increment
   */
  return _createClass(trackingController, [{
    key: "cookieIsUpToDate",
    value:
    /**
     * Compares the URL parameters with what's in the current cookie. True if cookie is up to date, otherwise false.
     * @param {Object} urlParams
     * @param {Object} cookieParams
     */
    function cookieIsUpToDate(urlParams, cookieParams) {
      if (Object.keys(urlParams).length === 0) {
        // if urlParams has no length, cookie is up to date.
        return true;
      } else if (Object.keys(cookieParams).length === 0 || Object.keys(urlParams).length !== Object.keys(cookieParams).length) {
        // case where there is no cookie or cookie has different num of params
        return false;
      }
      return this.cookieParamsAreUpToDate(urlParams, cookieParams);
    }

    /**
     * Checks to see if the param values in the url and the cookie are the same, returns true or false.
     * @param {Object} urlParams
     * @param {Object} cookieParams
     * @return {boolean}
     */
  }, {
    key: "cookieParamsAreUpToDate",
    value: function cookieParamsAreUpToDate(urlParams, cookieParams) {
      for (var i = 0; i < this.reqParams.length; i++) {
        var prop = this.reqParams[i];
        if (urlParams[prop] !== cookieParams[prop]) {
          return false;
        }
      }
      return true;
    }

    /**
     * Returns a cookie's values with the given name, if not found, returns -1.
     */
  }, {
    key: "getCookie",
    value: function getCookie() {
      var name = this.cookieName + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var splitCookie = decodedCookie.split(';');
      for (var i = 0; i < splitCookie.length; i++) {
        var c = splitCookie[i];
        c = c.trim();
        if (c.indexOf(name) === 0) {
          return c.substring(name.indexOf('=') + 1);
        }
      }
      return '';
    }

    /**
     * Retrieves query parameters from a given address.
     */
  }, {
    key: "getQueryParams",
    value: function getQueryParams() {
      var strAddress = this.address.toString();
      var params = strAddress.split('?');
      var paramMap = {};
      if (params.length > 1) {
        var paramPairs = params[1].split('&');
        paramPairs.forEach(function (currentValue) {
          var keyVal = currentValue.split('=');
          paramMap[keyVal[0]] = keyVal[1];
        });
      }
      return paramMap;
    }

    /**
     * Retrieves the parameter values from the user's current cookie.
     * @return {Object}
     */
  }, {
    key: "retrieveCookie",
    value: function retrieveCookie() {
      var cookie = this.getCookie();
      // Handles cookies with single param value
      if (this.reqParams.length === 1) {
        return cookie;
      }
      var cookieArray = [];
      if (cookie.toString() !== '') {
        cookieArray = cookie.toString().charAt(0) === '?' ? cookie.toString().substring(1).split(/&|=/) : cookie.toString().split(/&|=/);
      }
      return trackingController.arrayToParamObject(cookieArray);
    }

    /**
     * Retrieves the parameters listed in the URL given in the object.
     */
  }, {
    key: "retrieveParameters",
    value: function retrieveParameters() {
      var params = this.getQueryParams();
      var values = '';
      for (var i = 0; i < this.reqParams.length; i++) {
        var data = this.reqParams[i];
        if (params[data] !== undefined) {
          values = values.concat(data, '=', params[data], '&');
        }
      }
      return values;
    }

    /**
     * Performs cookie checks and overwrites to the tracked variables.
     */
  }, {
    key: "run",
    value: function run() {
      this.fetchedParams = this.retrieveParameters();
      this.cookieParams = this.retrieveCookie();
      var queryParam = this.fetchedParams !== '' ? this.fetchedParams.split(/&|=/) : [];
      var queryParamObj = trackingController.arrayToParamObject(queryParam);
      if (!this.cookieIsUpToDate(queryParamObj, this.cookieParams)) {
        // override existing cookie
        this.setCookie(this.fetchedParams, this.domain);
      }
    }

    /**
     * Performs cookie checks and overwrites variables based on input
     * @param {String} cookieValue
     */
  }, {
    key: "runWithoutFetch",
    value: function runWithoutFetch(cookieValue) {
      this.fetchedParams = cookieValue;
      this.cookieParams = this.retrieveCookie();

      // Set cookie if there is no cookie or the param values are different
      if (this.fetchedParams !== this.cookieParams) {
        this.setCookie(this.fetchedParams, this.domain);
      }
    }

    /**
     * Sets a cookie for the document based on the given parameters.
     * @param {string} cookieValues
     * @param {string} domain
     */
  }, {
    key: "setCookie",
    value: function setCookie(cookieValues, domain) {
      if (this.expiration < 1) {
        var domainString = domain === "" ? domain : "domain=" + domain + ";";
        document.cookie = "".concat(this.cookieName, "=").concat(encodeURIComponent(cookieValues), ";path=/;").concat(domainString);
      } else {
        var date = new Date();
        date.setTime(date.getTime() + this.expiration);
        var expires = "expires=" + date.toUTCString();
        var _domainString = domain === "" ? domain : "domain=" + domain + ";";
        document.cookie = "".concat(this.cookieName, "=").concat(encodeURIComponent(cookieValues), ";").concat(expires, ";path=/;").concat(_domainString);
      }
    }

    /**
     * Get the referrer
     * @param {Object} refData
     * @return {Object}
     */
  }], [{
    key: "arrayToParamObject",
    value: function arrayToParamObject(params) {
      var obj = {};
      var increment = 2;
      if (params.length !== 0) {
        for (var i = 0; i < params.length; i += increment) {
          obj[params[i]] = params[i + 1];
        }
      }
      return obj;
    }
  }, {
    key: "getReferrer",
    value: function getReferrer(refData) {
      var splitValue = 2;
      var refValue = document.referrer.split('/')[splitValue];
      if (refValue !== '' && refValue !== undefined && refValue !== 'www.snhu.edu') {
        if (refValue === 'www.google.com') {
          refData.refSource = 'google';
        } else if (refValue.endsWith('search.yahoo.com')) {
          refData.refSource = 'yahoo';
        } else if (refValue === 'www.bing.com') {
          refData.refSource = 'bing';
        } else if (refValue === 'duckduckgo.com') {
          refData.refSource = 'duckduckgo';
        } else {
          refData.refSource = refValue;
          refData.medium = 'referral';
        }
      } else {
        refData.refSource = 'direct';
        refData.medium = 'direct';
      }

      // Update the session referrer
      sessionStorage.setItem('Referrer_Value', refData.refSource);
      return refData;
    }
  }]);
}(); // export as a module for unit testing
if (typeof exports !== 'undefined') {
  module.exports = trackingController;
}

// Initialize and run in IIFE
(function () {
  var expiration = 2592000000; // 30 days

  // allow for local enviroment
  var domain = "snhu.edu";

  // Google Cross-Form Tracker Cookie
  var gCookieName = "GoogleString";
  var gParams = ["utm_source", "utm_medium", "utm_content", "utm_campaign", "utm_term", "snhu_segment"];
  var gTracker = new trackingController(window.location, gParams, gCookieName, expiration, domain);
  gTracker.run();

  // Paid Search Tracking
  var paidCookieName = "SNHUGlobalTracking";
  var paidParams = ["nan_pid", "ioguid", "k_clickid", "venpubid", "adxcel_clickid", "searchedterm", "pfsegment", "matchtype", "device", "msclkid", "gclid"];
  var paidTracker = new trackingController(window.location, paidParams, paidCookieName, expiration, domain);
  paidTracker.run();

  // SNHU Ad Tracking
  var adCookieName = "SNHUAdTracking";
  var adParams = ["adkeyword", "admatchtype", "addevice", "adcampaignid", "adgroupid", "adcampaignname", "adgroupname", "adquery", "adnetwork", "adlocationid", "adplacement"];
  var adTracker = new trackingController(window.location, adParams, adCookieName, expiration, domain);
  adTracker.run();
  window.addEventListener('load', function () {
    var gTrackerValue = gTracker.retrieveCookie();
    var refData = {
      referrerValue: sessionStorage.getItem('Referrer_Value'),
      refSource: 'No Referrer',
      medium: 'organic'
    };

    // Get the Referrer
    if (refData.referrerValue === null) {
      refData = trackingController.getReferrer(refData);
    }

    // If no utm parameters in the cookie, update the cookie
    if (Object.keys(gTrackerValue).length === 0) {
      var refCookie = 'utm_source=' + refData.refSource + '&utm_medium=' + refData.medium + '&utm_content=01&utm_campaign=SNHUEDU';
      gTracker.runWithoutFetch(refCookie);
    }

    // SNHU PrePop Cookie (SNHUProgramCode)
    var prepopButtons = document.querySelectorAll('a[data-program-code]');
    if (prepopButtons.length > 0) {
      var prepopTracker = new trackingController(window.location, ["programid"], "SNHUProgramCode", expiration, domain);
      var prepopLocation = new trackingController(window.location, ["programid"], "SNHULocationCode", expiration, domain);
      var prepopCategory = new trackingController(window.location, ["programid"], "SNHUCategoryId", expiration, domain);
      var prepopSubjectName = new trackingController(window.location, ["programid"], "SNHUSubjectName", expiration, domain);
      var prepopProgramID = new trackingController(window.location, ["programid"], "SNHUProgramId", expiration, domain);
      var prepopProgramGroupID = new trackingController(window.location, ["programid"], "SNHUProgramGroupId", expiration, domain);
      var prepopProgramName = new trackingController(window.location, ["programid"], "SNHUProgramName", expiration, domain);
      // Grabs first button with parent-program attribute
      var parentButton = document.querySelector('a[data-parent-program="true"]');
      if (parentButton !== null) {
        prepopTracker.runWithoutFetch(parentButton.getAttribute('data-program-code'));
        prepopLocation.runWithoutFetch(parentButton.getAttribute('data-location-code'));
        prepopCategory.runWithoutFetch(parentButton.getAttribute('data-category-id'));
        prepopSubjectName.runWithoutFetch(parentButton.getAttribute('data-subject'));
        prepopProgramID.runWithoutFetch(parentButton.getAttribute('data-program-id'));
        prepopProgramGroupID.runWithoutFetch(parentButton.getAttribute('data-program-group-id'));
        prepopProgramName.runWithoutFetch(parentButton.getAttribute('data-program-name'));
      }

      // Set user interaction functions for non-parent prepop buttons.
      var buttons = document.querySelectorAll('a[data-prepop="true"]:not([data-parent-program])');
      buttons.forEach(function (button) {
        var cookieValue = button.getAttribute('data-program-code');
        button.addEventListener('click', function () {
          prepopTracker.runWithoutFetch(cookieValue);
          prepopLocation.runWithoutFetch(button.getAttribute('data-location-code'));
          prepopCategory.runWithoutFetch(button.getAttribute('data-category-id'));
          prepopProgramID.runWithoutFetch(button.getAttribute('data-program-id'));
          prepopProgramGroupID.runWithoutFetch(button.getAttribute('data-program-group-id'));
        });
      });
    }

    // Set the InitialTab Cookie
    var indexTrue = -1;
    if (window.location.href.toLowerCase().indexOf('campus-majors') > indexTrue || window.location.href.toLowerCase().indexOf('online-degrees') > indexTrue) {
      var initialTabCookieName = 'Feature_Tabs_InitialTab';
      var initialTabParams = ['tablocation'];
      var initialTabTracker = new trackingController(window.location, initialTabParams, initialTabCookieName, expiration, domain);
      var cookieValue = window.location.href.toLowerCase().indexOf('campus-majors') > indexTrue ? 'Campus' : 'Online';
      initialTabTracker.runWithoutFetch(cookieValue);
    }

    // Set the RecentDegreeLevel Cookie
    var degreeLevels = ['certificates', 'associate', 'bachelors', 'masters', 'doctoral', 'undergraduate', 'graduate'];
    if (degreeLevels.some(function (degreeLevel) {
      return new RegExp('\\b' + degreeLevel.toLowerCase() + '\\b').test(window.location.href.toLowerCase());
    })) {
      var recentDegreeVisitedCookieName = 'RecentDegreeLevelVisited';
      var recentDegreeVisitTracker = new trackingController(window.location, ['optimizelyTestDegreeLevel'], recentDegreeVisitedCookieName, expiration, domain);
      var href = window.location.href.toLowerCase();
      var _cookieValue = '';
      if (href.indexOf('/certificates') > indexTrue) {
        _cookieValue = 'certificates';
      } else if (href.indexOf('/associate') > indexTrue) {
        _cookieValue = 'associate';
      } else if (href.indexOf('/bachelors') > indexTrue) {
        _cookieValue = 'bachelors';
      } else if (href.indexOf('/doctoral') > indexTrue) {
        _cookieValue = 'doctoral';
      } else if (href.indexOf('/undergraduate') > indexTrue) {
        if (href.indexOf('/bs-') > indexTrue || href.indexOf('/ba-') > indexTrue) {
          _cookieValue = 'bachelors';
        }
      } else if (href.indexOf('/masters') > indexTrue || href.indexOf('/graduate') > indexTrue) {
        _cookieValue = 'masters';
      }
      if (_cookieValue !== '') {
        recentDegreeVisitTracker.runWithoutFetch(_cookieValue);
      }
    }

    // Program Finder Cookies
    var pfLinks = document.querySelectorAll("a[href='/program-finder']");
    pfLinks.forEach(function (pfLink) {
      pfLink.addEventListener('click', function () {
        var degreeLevelCookie = new trackingController(window.location, ['pfDegreeLevel'], 'SNHUProgramFinder_DegreeLevel', null, domain);
        var areaOfStudyCookie = new trackingController(window.location, ['pfAreaOfStudy'], 'SNHUProgramFinder_AreaOfStudy', null, domain);
        var locationCookie = new trackingController(window.location, ['pfLocation'], 'SNHUProgramFinder_Location', null, domain);
        var breakpoint = 992;
        if (window.innerWidth >= breakpoint) {
          locationCookie.runWithoutFetch('All');
        } else {
          locationCookie.runWithoutFetch('DED');
        }
        if (pfLink.hasAttribute('data-pf-widget')) {
          var degreeLevel = document.getElementById('degree-level');
          var areaOfStudy = document.getElementById('category');
          degreeLevelCookie.runWithoutFetch(degreeLevel.value);
          areaOfStudyCookie.runWithoutFetch(areaOfStudy.value);
        } else {
          degreeLevelCookie.runWithoutFetch('All');
          areaOfStudyCookie.runWithoutFetch('All');
        }
      });
    });

    // Thank you page cookie is in the forms.js file
    // It needed to be created after the form has been validated and before the submit is completed
  });
})();
/* global CookieProvider */
var SuperCookieController = /*#__PURE__*/function () {
  /**
   * Constructor for SuperCookieController
   * @param {String} url
   * @param {CookieProvider} cookieProvider
   */
  function SuperCookieController(url, cookieProvider) {
    _classCallCheck(this, SuperCookieController);
    this.url = url;
    this.cookieProvider = cookieProvider || new CookieProvider();
  }

  /**
   * Returns the default expiration for super cookie, five years
   */
  return _createClass(SuperCookieController, [{
    key: "getCookie",
    value:
    /**
     * Gets the cookie from the document
     * if not found returns 0
     * if string found returns the number of urls in the cookie
     * if a number is found returns the number
     */
    function getCookie() {
      var superCookieValue = this.cookieProvider.getValueAsString(SuperCookieController.cookieName);
      if (superCookieValue === "") {
        return 0;
      }
      if (!isNaN(superCookieValue)) {
        var decimalRadix = 10;
        return Number.parseInt(superCookieValue, decimalRadix);
      }

      // Parse and then check if supercookie has an array of links
      var superCookieArrayParse = function superCookieArrayParse() {
        try {
          return JSON.parse(superCookieValue);
        } catch (e) {
          return {};
        }
      };
      var superCookieArray = superCookieArrayParse();
      if (superCookieArray.urls) {
        return superCookieArray.urls.length;
      }
      return 0;
    }

    /**
     * Sets the cookie in the document to the given cookie value
     * @param {String} cookieValue
     */
  }, {
    key: "setCookie",
    value: function setCookie(cookieValue) {
      var date = new Date();
      date.setTime(date.getTime() + SuperCookieController.expiration);
      this.cookieProvider.setCookie(SuperCookieController.cookieName, cookieValue, date);
    }

    /**
     * BuildCookie method used to get and set cookie based on controller object.
     */
  }, {
    key: "buildCookie",
    value: function buildCookie() {
      try {
        var cookieValue = this.getCookie();
        var newCookieValue = cookieValue + 1;
        this.setCookie(newCookieValue);
      } catch (e) {
        // These was an error building the cookie
      }
    }
  }], [{
    key: "expiration",
    get: function get() {
      // Equivalent to 400 days - max value for cookie expiration based on RFC 6265 and Chrome max
      var fourHundredDays = 34560000;
      return fourHundredDays;
    }

    /**
     * Returns the string value of the cookie's name
     */
  }, {
    key: "cookieName",
    get: function get() {
      return "snhuSuperCookie";
    }
  }]);
}(); // export as a module for unit testing
if (typeof exports !== 'undefined') {
  module.exports = SuperCookieController;
}

// IIFE
(function () {
  window.addEventListener("load", function () {
    var url = window.location.href;
    var snhuCookie = new CookieProvider();
    var controller = new SuperCookieController(url, snhuCookie);
    controller.buildCookie();
    if (sessionStorage.getItem('Landing_Page') === null) {
      sessionStorage.setItem('Landing_Page', url);
    }
  });
})();
/* global CookieProvider */
var AutomatedTestCookie = /*#__PURE__*/function () {
  function AutomatedTestCookie() {
    _classCallCheck(this, AutomatedTestCookie);
  }
  return _createClass(AutomatedTestCookie, null, [{
    key: "setAutomatedTestCookie",
    value: function setAutomatedTestCookie() {
      var cookieName = 'snhuAutomatedTest';
      var snhuCookie = new CookieProvider();
      if (snhuCookie.checkCookie(cookieName)) {
        return;
      }
      var cookieValue = '1';
      snhuCookie.setCookie(cookieName, cookieValue);
    }
  }, {
    key: "checkCampaign",
    value: function checkCampaign(queryStringParameters) {
      if (!queryStringParameters.has('utm_campaign')) {
        return false;
      }
      return queryStringParameters.get('utm_campaign').toLowerCase().includes('automatedtest');
    }

    /***
     * Test the following to indicate an automated test:
     *  ?utm_campaign=automatedtest
     *  ?automatedTest
     *  ?utm_campaign=automatedtestsubmission
     */
  }, {
    key: "checkUrlForTest",
    value: function checkUrlForTest() {
      var queryStringParameters = new URLSearchParams(window.location.search);
      if (queryStringParameters.has('automatedTest') || AutomatedTestCookie.checkCampaign(queryStringParameters) === true) {
        return true;
      }
      return false;
    }
  }]);
}(); // export as a module for unit testing
if (typeof exports !== 'undefined') {
  module.exports = AutomatedTestCookie;
}
window.addEventListener('load', function () {
  if (AutomatedTestCookie.checkUrlForTest()) {
    AutomatedTestCookie.setAutomatedTestCookie();
  }
});
var chatBoxTrackingParams = function () {
  function arrayToParamObject(params) {
    var obj = {};
    var increment = 2;
    if (params.length !== 0) {
      for (var i = 0; i < params.length; i += increment) {
        obj[params[i]] = params[i + 1];
      }
    }
    return obj;
  }

  /**
   * Returns a cookie's values with the given name, if not found, returns -1.
   */
  function getCookie(cName) {
    var name = cName + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var splitCookie = decodedCookie.split(';');
    for (var i = 0; i < splitCookie.length; i++) {
      var c = splitCookie[i];
      c = c.trim();
      if (c.indexOf(name) === 0) {
        return c.substring(name.indexOf('=') + 1);
      }
    }
    return '';
  }
  function _getCookieValues() {
    if (document.cookie.length > 0) {
      // Get the standard UTM values
      var utmCookie = getCookie('GoogleString');
      var cookieArray = [];
      if (utmCookie.toString() !== '') {
        cookieArray = utmCookie.toString().charAt(0) === '?' ? utmCookie.toString().substring(1).split(/&|=/) : utmCookie.toString().split(/&|=/);
      }

      // Get the Google ID
      var googleID = getCookie('_gid');
      if (googleID !== '') {
        cookieArray.push('Google_ID__c', googleID);
      }

      // Get the Referrer
      // This script will load before the supercookie if a user lands on a page with the chat box as the first page they visit
      if (sessionStorage.getItem('Referrer_Value') === null) {
        var splitValue = 2;
        var referrerValue = document.referrer.split('/')[splitValue];
        if (referrerValue !== '' && referrerValue !== undefined && referrerValue !== 'www.snhu.edu') {
          var refSource;
          if (referrerValue === 'www.google.com') {
            refSource = 'google';
          } else if (referrerValue.endsWith('search.yahoo.com')) {
            refSource = 'yahoo';
          } else if (referrerValue === 'www.bing.com') {
            refSource = 'bing';
          } else if (referrerValue === 'duckduckgo.com') {
            refSource = 'duckduckgo';
          } else {
            refSource = referrerValue;
          }
          cookieArray.push('Referrer', refSource);
        } else {
          cookieArray.push('Referrer', 'direct');
        }
      } else {
        cookieArray.push('Referrer', sessionStorage.getItem('Referrer_Value'));
      }
      var landingPage = sessionStorage.getItem('Landing_Page');
      if (landingPage !== null) {
        cookieArray.push('Landing_Page', landingPage);
      } else {
        cookieArray.push('Landing_Page', window.location.href);
      }
      return arrayToParamObject(cookieArray);
    }
    return '';
  }
  return {
    getCookieValues: _getCookieValues
  };
}();
if (typeof exports !== 'undefined') {
  module.exports = chatBoxTrackingParams;
}
/* global ecommerceCookieController */
var EcommerceCookie = /*#__PURE__*/function () {
  function EcommerceCookie() {
    _classCallCheck(this, EcommerceCookie);
  }
  return _createClass(EcommerceCookie, null, [{
    key: "setEcommerceCookie",
    value:
    /* set the cookie for the ecommerce cookie - google
     11/23/2021 - this was moved out of the _submitValidatedForm and now returns a promise. No additional updates. */
    function setEcommerceCookie(data) {
      return new Promise(function (resolve) {
        // Build ecommerce cookie after action, if the appropriate fields are provided
        if (data.leadid > 0) {
          var cookieDomain = "snhu.edu";
          var cookieParams = ['leadid', 'conversionid', 'stagenum', 'formsource', 'academiclevel', 'programcode', 'location'];
          var cookieName = 'snhuEconTransation';
          var expires = new Date();
          expires.setDate(expires.getDate() + 1);
          var cookie = new ecommerceCookieController(window.location, cookieParams, cookieName, expires, cookieDomain);
          // Build cookie value
          var cookieValue = '';
          cookieParams.forEach(function (param) {
            if (param !== 'location') {
              cookieValue += "".concat(param, ":").concat(data[param], ",");
            }
          });
          cookieValue += "location:".concat(data.location === 'ded' ? 'online' : 'campus');

          // Sets the document.cookie
          cookie.runWithoutFetch(cookieValue);
        }
        resolve(data);
      });
    }
  }]);
}();
/* istanbul ignore next */
if (typeof exports !== 'undefined') {
  module.exports = EcommerceCookie;
}
/* global FormUtilities */
/* global CookieProvider */
var FormSubmitCookie = /*#__PURE__*/function () {
  function FormSubmitCookie() {
    _classCallCheck(this, FormSubmitCookie);
  }
  return _createClass(FormSubmitCookie, null, [{
    key: "getProgramName",
    value: function getProgramName(form) {
      var programNameField = form.getAttribute('data-tyc-pname');
      if (programNameField) {
        var programDropdown = document.getElementById(programNameField);
        return FormSubmitCookie.getSelectedIndexText(programDropdown);
      }
      return "";
    }
  }, {
    key: "getAreaOfStudy",
    value: function getAreaOfStudy(form) {
      var areaOfStudyField = form.querySelector('[data-form-field="areaOfStudy"]');
      if (areaOfStudyField) {
        return FormSubmitCookie.getSelectedIndexText(areaOfStudyField);
      }
      return "";
    }
  }, {
    key: "getEnrollmentTerm",
    value: function getEnrollmentTerm(form, location) {
      var enrollmentTermField = form.querySelector('[data-form-field="startTerm"]');
      if (enrollmentTermField && location === 'campus') {
        return FormSubmitCookie.getSelectedIndexText(enrollmentTermField);
      }
      return "";
    }
  }, {
    key: "getSelectedIndexText",
    value: function getSelectedIndexText(dropdownField) {
      return dropdownField ? dropdownField.options[dropdownField.selectedIndex].text : '';
    }
  }, {
    key: "getValueIfItExists",
    value: function getValueIfItExists(form, selector) {
      var element = form.querySelector(selector);
      return element ? element.value : '';
    }
  }, {
    key: "setFormSubmitCookie",
    value: function setFormSubmitCookie(form, data) {
      return new Promise(function (resolve) {
        var cookieName = 'formSubmitCookie';
        var snhuCookie = new CookieProvider();
        var programName = data.experienceachievement;
        var areaOfStudy = data.fieldofstudy;
        var location = data.location === 'ded' ? 'online' : 'campus';
        var enrollmentTerm = data.enrollmentterm;
        var degreeLevel = data.academiclevel;
        var programCode = data.programcode;
        var categoryId = data.fieldofstudycode;
        var formSource = data.formsource;
        var isIntlStudent = data.isinternationalstudent;
        var militaryStatus = data.militarystatus ? data.militarystatus : '';
        var militaryBranch = data.militarybranch ? data.militarybranch : '';
        var militaryAffiliation = data.militaryaffiliation ? data.militaryaffiliation.toLowerCase() : '';
        var zipCode = data.zipcode;
        var leadId = data.leadid;
        var formUtilities = new FormUtilities(form);
        var formType = formUtilities.getFormType();
        var prePopulated = formUtilities.isPrepopulated();
        var cookieValue = "programName:".concat(programName, ",programCode:").concat(programCode, ",categoryId:").concat(categoryId, ",formType:").concat(formType, ",prePopulated:").concat(prePopulated, ",formSource:").concat(formSource, ",enrollmentTerm:").concat(enrollmentTerm, ",programAffiliation:").concat(location, ",degreeLevel:").concat(degreeLevel, ",areaOfStudy:").concat(areaOfStudy, ",leadId:").concat(leadId, ",isIntlStudent:").concat(isIntlStudent, ",militaryStatus:").concat(militaryStatus, ",militaryBranch:").concat(militaryBranch, ",militaryAffiliation:").concat(militaryAffiliation, ",zipCode:").concat(zipCode);
        snhuCookie.setCookie(cookieName, cookieValue);
        resolve(data);
      });
    }
  }]);
}();
/* istanbul ignore next */
if (typeof exports !== 'undefined') {
  module.exports = FormSubmitCookie;
}
/* global SnhuCookieUtil */
var ThankYouCookie = /*#__PURE__*/function () {
  function ThankYouCookie() {
    _classCallCheck(this, ThankYouCookie);
  }
  return _createClass(ThankYouCookie, null, [{
    key: "getFirstName",
    value: function getFirstName(form) {
      var firstNameField = form.getAttribute('data-tyc-fname');
      if (firstNameField) {
        return form[firstNameField].value;
      }
      return "";
    }
  }, {
    key: "getLastName",
    value: function getLastName(form) {
      var lastNameField = form.getAttribute('data-tyc-lname');
      if (lastNameField) {
        return form[lastNameField].value;
      }
      return "";
    }
  }, {
    key: "getProgramName",
    value: function getProgramName(form) {
      var programNameField = form.getAttribute('data-tyc-pname');
      if (programNameField) {
        //programName = form[programNameField].value;
        var programDropdown = document.getElementById(programNameField);
        return programDropdown.options[programDropdown.selectedIndex].text;
      }
      return "";
    }
    /*eslint-enable class-methods-use-this */

    /* set the cookie for the thank you page */
  }, {
    key: "storeThankYouValues",
    value: function storeThankYouValues(form, data) {
      return new Promise(function (resolve) {
        if (form.hasAttribute('data-tyc-fname') && form.hasAttribute('data-tyc-lname') && form.hasAttribute('data-tyc-pname')) {
          var cookieName = 'snhuThankYouCookie';
          var snhuCookie = new SnhuCookieUtil(cookieName);
          var firstName = ThankYouCookie.getFirstName(form);
          var lastName = ThankYouCookie.getLastName(form);
          var programName = ThankYouCookie.getProgramName(form);
          var encryptedLeadId = data.encryptedleadid;
          var responseTimeout = data.responsetimeoutinsecond;
          var cookieValue = "firstname:".concat(encodeURI(firstName), ",lastname:").concat(encodeURI(lastName), ",programname:").concat(programName, ",encryptedleadid:").concat(encryptedLeadId, ",responsetimeoutinsecond:").concat(responseTimeout);
          snhuCookie.setCookie(cookieValue);
        }
        resolve(data);
      });
    }
  }]);
}();
/* istanbul ignore next */
if (typeof exports !== 'undefined') {
  module.exports = ThankYouCookie;
}
var CourseCostsController = /*#__PURE__*/function () {
  function CourseCostsController() {
    _classCallCheck(this, CourseCostsController);
  }
  return _createClass(CourseCostsController, null, [{
    key: "adjustAriaExpandedForViewport",
    value: function adjustAriaExpandedForViewport() {
      var screenMaxWidthChange = 992;
      if (window.innerWidth > screenMaxWidthChange) {
        //desktop - add aria-expanded
        document.querySelectorAll('[data-toggle-trigger].student-type').forEach(function (trigger) {
          trigger.setAttribute('aria-expanded', 'true');
        });
        return;
      }

      //mobile - aria-expanded on first accordion only
      var isfirst = true;
      document.querySelectorAll('[data-toggle-trigger].student-type').forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', isfirst);
        isfirst = false;
      });
    }
  }]);
}();
/* istanbul ignore next */
if (typeof exports !== 'undefined') {
  module.exports = CourseCostsController;
}
addEventListener('load', function () {
  CourseCostsController.adjustAriaExpandedForViewport();
});
addEventListener('resize', function () {
  CourseCostsController.adjustAriaExpandedForViewport();
});
var CourseAccordionController = /*#__PURE__*/function () {
  function CourseAccordionController() {
    _classCallCheck(this, CourseAccordionController);
  }
  return _createClass(CourseAccordionController, null, [{
    key: "adjustForViewport",
    value: function adjustForViewport() {
      var screenMaxWidthChange = 992;
      if (window.innerWidth > screenMaxWidthChange) {
        //select accordion item
        document.querySelectorAll('[data-course-accordion-item]').forEach(function (courseItem) {
          var courseId = courseItem.querySelector('[data-course-code]');
          var courseTitle = courseItem.querySelector('[data-toggle-trigger]');
          if (courseId && courseTitle) {
            courseTitle.prepend(courseId);
          }
        });
        return;
      }

      //mobile - aria-expanded on first accordion only
      document.querySelectorAll('[data-course-accordion-item]').forEach(function (courseItem) {
        var courseId = courseItem.querySelector('[data-course-code]');
        var coursePanel = courseItem.querySelector('[data-details-ease]');
        if (courseId && coursePanel) {
          coursePanel.prepend(courseId);
        }
      });
    }
  }]);
}();
/* istanbul ignore next */
if (typeof exports !== 'undefined') {
  module.exports = CourseAccordionController;
}
addEventListener('load', function () {
  CourseAccordionController.adjustForViewport();
});
addEventListener('resize', function () {
  CourseAccordionController.adjustForViewport();
});
// NOTE: Gulp adds this file to /components/Legacy, changes should be applied to the file found in /components/Feature

/**
 * Controls the behavior of the primary skip navigation and jump links
 */
var SkipNavigationController = /*#__PURE__*/function () {
  function SkipNavigationController() {
    _classCallCheck(this, SkipNavigationController);
  }
  return _createClass(SkipNavigationController, null, [{
    key: "mainElement",
    get:
    /**
     * Return the <main> tag as a node
     * @return Node
     */
    function get() {
      return document.querySelector(SkipNavigationController.skipNavButton.getAttribute('href'));
    }

    /**
     * Returns the string used to find focusable elements
     * @return String
     */
  }, {
    key: "focusableQueryString",
    get: function get() {
      return 'button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
    }

    /**
     * Returns the skip navigation button as a node.
     * @return Node
     */
  }, {
    key: "skipNavButton",
    get: function get() {
      return document.querySelector('.skip-navigation');
    }

    /**
     * Remove the overlay
     */
  }, {
    key: "removeOverlay",
    value: function removeOverlay(a) {
      document.querySelector('.modal-backdrop').classList.remove('show');
      a.classList.remove('overlay-focus');
    }
  }, {
    key: "escapeKeyRemoveOverlay",
    value: function escapeKeyRemoveOverlay(e, a) {
      var key = e.key;
      if (key === 'Escape' || key === 'Esc') {
        SkipNavigationController.removeOverlay(a);
      }
    }
  }, {
    key: "offClickRemoveOverlay",
    value: function offClickRemoveOverlay(e, a) {
      var notFound = -1;
      if ((!e.target.href || e.target.href.indexOf(a.id) === notFound) && e.target.closest('.modal-content') === null) {
        SkipNavigationController.removeOverlay(a);
      }
    }

    /**
     * Show the overlay
     * @param {Node} a
     */
  }, {
    key: "showOverlay",
    value: function showOverlay(a) {
      var modalDiv = document.querySelector('.modal-backdrop');
      if (modalDiv !== undefined) {
        modalDiv.classList.add('show');
        a.classList.add('overlay-focus');

        // Escape Key event
        document.addEventListener('keydown', function (e) {
          e.preventDefault();
          SkipNavigationController.escapeKeyRemoveOverlay(e, a);
        });

        // Overlay off click event
        document.addEventListener('click', function (e) {
          e.preventDefault();
          SkipNavigationController.offClickRemoveOverlay(e, a);
        });
      }
    }

    /**
     * Sets the focus of the document in the first focusable item in the given main element or the target itself
     * @param {Node} e
     */
  }, {
    key: "setFocusItem",
    value: function setFocusItem(e) {
      if (e !== null) {
        // 5/16/22 - This code is also temporary
        if (e.hasAttribute('tabindex') || e.tagName.toLocaleLowerCase() === 'select' || e.tagName.toLocaleLowerCase() === 'input') {
          e.focus();
        } else {
          var focusables = e.querySelectorAll(SkipNavigationController.focusableQueryString);
          for (var i = 0; i < focusables.length; i++) {
            if (focusables[i].closest('header') === null) {
              focusables[i].focus();
              break;
            }
          }
        }
      }
    }

    /**
     * Sets the scrollto location for the jump link target so it isn't behind the sticky primary nav
     * @param {Node} scrollTarget
     */
  }, {
    key: "scrollToArea",
    value: function scrollToArea(scrollTarget) {
      /* eslint-disable no-magic-numbers */
      var offset = 50; // Height of the mobile primary nav
      var mobileViewPort = 991;
      if (window.innerWidth > mobileViewPort) {
        offset = 137; // Height of the desktop primary nav
      }
      /* eslint-enable no-magic-numbers */

      var y = scrollTarget.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });
    }

    /**
     * Initate all the work to scroll to and set any additional settings
     * @param {Node} a
     */
  }, {
    key: "skipNavInit",
    value: function skipNavInit(a) {
      var targetItem = document.getElementById(a.getAttribute('href').replace('#', ''));
      if (targetItem !== null) {
        // If the target is a form show the overaly and set focus on the appropriate form element
        if (a.getAttribute('href').indexOf('form') > -1) {
          this.setFocusItem(targetItem);
        } else {
          this.showOverlay(targetItem);
        }
        this.scrollToArea(targetItem);
      }
    }
  }]);
}(); // Export for Jest testing
if (typeof exports !== 'undefined') {
  module.exports = SkipNavigationController;
}

/* global GA4EventFactory */
/* global NavigationFactory */
/* global AddToCart */
var NavigationController = /*#__PURE__*/function () {
  function NavigationController(gA4EventFactory) {
    _classCallCheck(this, NavigationController);
    this.ga4EventFactory = gA4EventFactory || new GA4EventFactory('navigation_click');
  }
  return _createClass(NavigationController, [{
    key: "bindNavClickListener",
    value: function bindNavClickListener(link, location) {
      var that = this;
      link.onclick = function () {
        var eventData = NavigationFactory.createClickEventData(location, link.text);
        that.ga4EventFactory.create(eventData);
      };
    }
  }, {
    key: "bindMySnhuListener",
    value: function bindMySnhuListener(link) {
      var that = this;
      link.onclick = function () {
        var eventData = NavigationFactory.createMySnhuClickEventData();
        that.ga4EventFactory.create(eventData);
      };
    }
  }]);
}();
window.addEventListener('load', function () {
  var navigationController = new NavigationController();
  var header = document.getElementsByTagName('header')[0];
  if (header) {
    header.querySelectorAll('nav a').forEach(function (link) {
      navigationController.bindNavClickListener(link, 'header');
    });
  }
  var footer = document.getElementsByTagName('footer')[0];
  if (footer) {
    footer.querySelectorAll('nav a').forEach(function (link) {
      navigationController.bindNavClickListener(link, 'footer');
    });
  }
  var relatedLinks = document.getElementsByClassName('related-links');
  if (relatedLinks.length) {
    Array.from(relatedLinks).forEach(function (relatedLink) {
      relatedLink.querySelectorAll('nav a').forEach(function (link) {
        navigationController.bindNavClickListener(link, 'aside');
      });
    });
  }
  var breadcrumb = document.getElementsByClassName('breadcrumb')[0];
  if (breadcrumb) {
    breadcrumb.querySelectorAll('.breadcrumb-item a').forEach(function (link) {
      navigationController.bindNavClickListener(link, 'breadcrumb');
    });
  }
  var mySnhuLinks = document.querySelectorAll('a[href*="my.snhu.edu"]');
  if (mySnhuLinks.length) {
    mySnhuLinks.forEach(function (link) {
      navigationController.bindMySnhuListener(link);
    });
  }

  /**
   * On click of prepop button
   * fire add_to_cart event
   * with program data
   */

  var prepopButtons = document.querySelectorAll('a[data-program-code]');
  if (!prepopButtons.length) {
    return;
  }
  var ga4EventFactory = new GA4EventFactory('add_to_cart');
  prepopButtons.forEach(function (prepopButton) {
    prepopButton.addEventListener('click', function () {
      var programPrepopButtonClick = new AddToCart();
      ga4EventFactory.create(programPrepopButtonClick.create());
    });
  });
});
/* global GA4EventFactory */
/* global ViewItem */
/* global PageViewFactory */
var PageController = /*#__PURE__*/function () {
  function PageController(pageView, ga4EventFactory) {
    _classCallCheck(this, PageController);
    this.pageView = pageView || new PageViewFactory();
    this.ga4Event = ga4EventFactory || new GA4EventFactory('pageview');
  }
  return _createClass(PageController, [{
    key: "PageViewEvent",
    value: function PageViewEvent() {
      var pageViewData = this.pageView.create();
      this.ga4Event.create(pageViewData);
    }
  }]);
}();
if (typeof exports !== 'undefined') {
  module.exports = PageController;
}
window.addEventListener('load', function () {
  var pageViewController = new PageController();
  pageViewController.PageViewEvent();
  var isProgramPage = document.querySelector('a[data-parent-program="true"]');
  if (!isProgramPage) {
    return;
  }
  var gA4EventFactory = new GA4EventFactory("view_item");
  var programPageView = new ViewItem();
  var dimensionWritten = new GA4EventFactory("dimensionsWritten");
  gA4EventFactory.create(programPageView.create());
  dimensionWritten.create();
});
/* global AiChatFactory */
/* global GA4EventFactory */

(function () {
  window.addEventListener("load", function () {
    var aiOpenChat = document.getElementById("open-ai-chat");
    function handleAiChatOpen() {
      var ga4AiChatOpenEvent = new GA4EventFactory("AI_chat_open");
      var aiChatOpened = AiChatFactory.createAiChatOpen();
      ga4AiChatOpenEvent.create(aiChatOpened);
    }
    if (aiOpenChat) {
      aiOpenChat.addEventListener("click", handleAiChatOpen);
    }
  });
})();
var NavigationFactory = /*#__PURE__*/function () {
  function NavigationFactory() {
    _classCallCheck(this, NavigationFactory);
  }
  return _createClass(NavigationFactory, null, [{
    key: "createClickEventData",
    value: function createClickEventData(linkLocation, linkText) {
      return {
        'click': {
          'navigation_place': linkLocation,
          'navigation_category': '',
          'navigation_item': linkText.trim()
        }
      };
    }
  }, {
    key: "createMySnhuClickEventData",
    value: function createMySnhuClickEventData() {
      return {
        'event': 'my_snhu_click'
      };
    }
  }]);
}();
if (typeof exports !== "undefined") {
  module.exports = NavigationFactory;
}
/* global CookieProvider */
/* global templateId */
var PageViewFactory = /*#__PURE__*/function () {
  function PageViewFactory(snhuCookieProvider) {
    _classCallCheck(this, PageViewFactory);
    this.snhuCookieProvider = snhuCookieProvider || new CookieProvider();
    this.formSubmitCookieValues = this.snhuCookieProvider.getValueAsJson("formSubmitCookie");
    this.croTestCookieValue = this.snhuCookieProvider.getValueAsString("ssTestIds");
    this.snhuCommunityMemberValue = this.snhuCookieProvider.getValueAsString("snhucommunitymember");
    this.templateId = typeof templateId !== 'undefined' ? templateId : '';
  }
  return _createClass(PageViewFactory, [{
    key: "create",
    value: function create() {
      return {
        'page': {
          'vendor_unique_id': this.formSubmitCookieValues.leadId || '',
          'content_group': '',
          'program_page_group': '',
          'online_degrees_section': '',
          'template_id': this.templateId
        },
        'user': {
          'user_time_zone': Intl.DateTimeFormat().resolvedOptions().timeZone,
          'cro_test_id': this.croTestCookieValue || '',
          'international_student': this.formSubmitCookieValues.isIntlStudent || '',
          'military_status': this.formSubmitCookieValues.militaryStatus || '',
          'military_branch': this.formSubmitCookieValues.militaryBranch || '',
          'military_affiliation': this.formSubmitCookieValues.militaryAffiliation || '',
          'zip_code': this.formSubmitCookieValues.zipCode || ''
        }
      };
    }
  }]);
}();
if (typeof exports !== 'undefined') {
  module.exports = PageViewFactory;
}
var AiChatFactory = /*#__PURE__*/function () {
  function AiChatFactory() {
    _classCallCheck(this, AiChatFactory);
  }
  return _createClass(AiChatFactory, null, [{
    key: "createAiChatOpen",
    value: function createAiChatOpen() {
      return {
        'metric': {
          'AI_chat_open': '1'
        }
      };
    }
  }, {
    key: "createAiChatStart",
    value: function createAiChatStart() {
      return {
        'metric': {
          'AI_chat_start': '1'
        }
      };
    }
  }]);
}();
/* istanbul ignore next */
if (typeof exports !== "undefined") {
  module.exports = AiChatFactory;
}
var InnerNavigationController = /*#__PURE__*/function () {
  function InnerNavigationController(innerNavbar) {
    _classCallCheck(this, InnerNavigationController);
    this.innerNavbar = innerNavbar;
    this.lastScrollPosition = 0;
  }

  /**
   * Sets the top for the inner nav - needed to deal with the alert or open search
   */
  return _createClass(InnerNavigationController, [{
    key: "handleInnerNavTopOffset",
    value: function handleInnerNavTopOffset() {
      var primaryNav = document.querySelector('header');
      if (!primaryNav) {
        return;
      }
      this.innerNavbar.style.top = Number(primaryNav.offsetHeight) + 'px';
    }
  }, {
    key: "calHorizontalScroll",
    value: function calHorizontalScroll(link) {
      var leftPadding = 15;
      var innerNav = document.getElementById('innerNav');
      if (!innerNav) {
        return 0;
      }
      var innerNavRect = innerNav.getBoundingClientRect();
      var linkRect = link.getBoundingClientRect();
      if (window.scrollY > this.lastScrollPosition) {
        //this is for scrolling down the page
        return (innerNavRect.x - linkRect.x - leftPadding) * -1;
      }

      //this is for scrolling up the page
      return (innerNavRect.right - linkRect.right + leftPadding) * -1;
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "targetContainerEnd",
    value: function targetContainerEnd(targetContainerRect, nextTargetContainer) {
      if (nextTargetContainer) {
        var nextTargetContainerRect = nextTargetContainer.getBoundingClientRect();
        return nextTargetContainerRect.top + window.scrollY;
      }
      return targetContainerRect.bottom + window.scrollY;
    }

    /**
     * Handle active state of inner nav links
     *
     * @param {any} link innerNav link
     * @param {any} targetContainer target of link
     * @param {any} nextTargetContainer next inner nav target - needed for areas of page that are not within the innernav
     */

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "getViewportPadding",
    value: function getViewportPadding() {
      var screenMaxWidthChange = 768;
      var largeViewportPadding = 240;
      var smallViewportPadding = 110;
      return window.innerWidth > screenMaxWidthChange ? largeViewportPadding : smallViewportPadding;
    }
  }, {
    key: "handleAnchorActiveOnScroll",
    value: function handleAnchorActiveOnScroll() {
      var foundActive = false;
      var innerNavLinks = this.innerNavbar.querySelectorAll('a');
      for (var i = 0; i < innerNavLinks.length; i++) {
        if (!foundActive) {
          var linkItemTarget = document.getElementById(innerNavLinks[i].getAttribute('href').replace('#', ''));
          var targetContainer = this.getLinkTartgetContainer(linkItemTarget);
          if (!targetContainer) {
            continue;
          }
          var nextLinkItemTarget = document.getElementById(innerNavLinks[i + 1] ? innerNavLinks[i + 1].getAttribute('href').replace('#', '') : null);
          var nextTargetContainer = this.getLinkTartgetContainer(nextLinkItemTarget);
          var targetContainerRect = targetContainer.getBoundingClientRect();
          var targetContainerStart = targetContainerRect.top + window.scrollY;
          var headerHeight = document.querySelector('header').offsetHeight; // bottom of the header
          var fromTop = headerHeight + this.innerNavbar.offsetHeight + window.scrollY + this.getViewportPadding();
          if (fromTop >= targetContainerStart && this.targetContainerEnd(targetContainerRect, nextTargetContainer) > fromTop) {
            foundActive = true;
            this.lastScrollPosition = Number(window.scrollY);
            innerNavLinks[i].classList.add('active');
            this.innerNavbar.scrollTo({
              top: 0,
              left: this.calHorizontalScroll(innerNavLinks[i]),
              behavior: 'smooth'
            });
          } else {
            innerNavLinks[i].classList.remove('active');
          }
        } else {
          innerNavLinks[i].classList.remove('active');
        }
      }
    }
    /**
     * Intercept the click event on the inner nav links so we can scroll with a smooth animation and the correct offset
     * @param {any} event click event
     * @param {any} targetContainer rendering containing target
     */

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "handleAnchorOnClick",
    value: function handleAnchorOnClick(event, targetContainer, target) {
      var viewportPadding = 60; // a little extra padding so the title isn't tight against the inner nav
      var headerHeight = document.querySelector('header').offsetHeight; // bottom of the header  //add null check
      var targetContainerRect = targetContainer.getBoundingClientRect();
      var targetContainerStart = targetContainerRect.top + window.scrollY - headerHeight - viewportPadding;
      target.focus();
      event.preventDefault();
      window.scrollTo({
        top: targetContainerStart,
        behavior: 'smooth'
      });
      var currentactive = this.innerNavbar.querySelector('.active');
      if (currentactive !== event.target) {
        if (currentactive) {
          // remove the active class from the current active link
          currentactive.classList.remove('active');
        }
        event.target.classList.add('active');
      }
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "getLinkTartgetContainer",
    value: function getLinkTartgetContainer(target) {
      if (!target) {
        return false;
      }
      var section = target.closest("[data-rendering]");
      if (!section) {
        return false;
      }
      return section;
    }

    /**
    * Get a list of inner nav link nodes
    * We will assume the nodes are in the same order as the inner nav links (which they should be!)
    * Set up a scroll event listener for each valid link
    */
  }, {
    key: "setUpInnerNavClick",
    value: function setUpInnerNavClick() {
      var _this9 = this;
      var innerNavLinks = this.innerNavbar.querySelectorAll('a');
      var _loop = function _loop() {
        var linkItemTarget = document.getElementById(innerNavLinks[i].getAttribute('href').replace('#', ''));
        var targetContainer = _this9.getLinkTartgetContainer(linkItemTarget);
        if (!targetContainer) {
          return 1; // continue
        }
        innerNavLinks[i].addEventListener('click', function (e) {
          return _this9.handleAnchorOnClick(e, targetContainer, linkItemTarget);
        });
      };
      for (var i = 0; i < innerNavLinks.length; i++) {
        if (_loop()) continue;
      }
    }
    /*eslint-disable-next-line*/
  }, {
    key: "throttleScroll",
    value: function throttleScroll(callback) {
      var wait = false;
      var limit = 200;
      return function () {
        if (!wait) {
          callback.apply(null, arguments);
          wait = true;
          setTimeout(function () {
            wait = false;
          }, limit);
        }
      };
    }
  }, {
    key: "init",
    value: function init() {
      this.handleInnerNavTopOffset();
      addEventListener('scroll', this.throttleScroll(this.handleInnerNavTopOffset.bind(this)));
      this.setUpInnerNavClick();
      var handleActive = this.throttleScroll(this.handleAnchorActiveOnScroll.bind(this));
      addEventListener('scroll', handleActive);
    }
  }]);
}(); // export as a module for unit testing
if (typeof exports !== 'undefined') {
  module.exports = InnerNavigationController;
}
addEventListener('load', function () {
  var innerNavbar = document.getElementById('innerNavbar');
  /* Added the check for the scEnabledChrome class to prevent nav blocking page content in Experience Editor   */
  if (innerNavbar && !this.innerNavbar.classList.contains('scEnabledChrome')) {
    var innerNavController = new InnerNavigationController(innerNavbar);
    innerNavController.init();
  }
});
var TransferCreditsController = /*#__PURE__*/function () {
  function TransferCreditsController() {
    _classCallCheck(this, TransferCreditsController);
  }
  return _createClass(TransferCreditsController, null, [{
    key: "handleCreditClick",
    value:
    /**
     * Shows the credit-amount- and description- for the credit clicked
     */

    function handleCreditClick(e) {
      var clicked = e.target;
      var creditId = clicked.id.replace('transfer-credit-savings-', '');
      var creditAmount = document.getElementById('credit-amount-' + creditId);
      var creditDescription = document.getElementById('credit-description-' + creditId);
      TransferCreditsController.hideDisplayedAmountDescription();
      if (!creditAmount) {
        return;
      }
      creditAmount.classList.replace('d-none', 'd-block');
      if (!creditDescription) {
        return;
      }
      creditDescription.classList.replace('d-none', 'd-block');
    }
  }, {
    key: "hideDisplayedAmountDescription",
    value: function hideDisplayedAmountDescription() {
      var showingCreditAmount = document.querySelector("[data-credit-description].d-block");
      if (showingCreditAmount) {
        showingCreditAmount.classList.replace('d-block', 'd-none');
      }
      var showingDescription = document.querySelector("[data-credit-amount].d-block");
      if (showingDescription) {
        showingDescription.classList.replace('d-block', 'd-none');
      }
    }
  }]);
}(); // export as a module for unit testing
if (typeof exports !== 'undefined') {
  module.exports = TransferCreditsController;
}
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll("input[data-credit-savings]").forEach(function (transferCredit) {
    transferCredit.addEventListener('click', function (e) {
      TransferCreditsController.handleCreditClick(e);
    });
  });
});
var TestimonialsGroupController = /*#__PURE__*/function () {
  function TestimonialsGroupController(testimonialsGroup) {
    _classCallCheck(this, TestimonialsGroupController);
    this.testimonialsGroup = testimonialsGroup;
    this.testimonials = [];
    this.currentTestimonial = null;
  }
  return _createClass(TestimonialsGroupController, [{
    key: "init",
    value: function init() {
      this.creatTestimonialObjects();
      this.bindClickEvents();
    }
  }, {
    key: "creatTestimonialObjects",
    value: function creatTestimonialObjects() {
      var thumbnails = Array.from(this.testimonialsGroup.querySelectorAll('[data-testimonial-thumbnail]'));
      var contents = Array.from(this.testimonialsGroup.querySelectorAll('[data-testimonial-detail]'));
      this.testimonials = thumbnails.map(function (thumbnail, index) {
        return {
          thumbnail: thumbnail,
          content: contents[index]
        };
      });
      this.currentTestimonial = this.testimonials[0];
    }
  }, {
    key: "bindClickEvents",
    value: function bindClickEvents() {
      var _this10 = this;
      this.testimonials.forEach(function (testimonial) {
        testimonial.thumbnail.addEventListener('click', function () {
          return _this10.showTestimonial(testimonial);
        });
      });
    }
  }, {
    key: "showTestimonial",
    value: function showTestimonial(testimonial) {
      // Hide the current testimonial if it exists
      if (this.currentTestimonial) {
        this.currentTestimonial.content.setAttribute("aria-hidden", true);
        this.currentTestimonial.thumbnail.classList.remove("active");
      }

      // Show the new testimonial
      testimonial.content.removeAttribute("aria-hidden");
      testimonial.thumbnail.classList.add("active");

      // Update the current testimonial
      this.currentTestimonial = testimonial;
    }
  }]);
}();
/* istanbul ignore next */
if (typeof exports !== 'undefined') {
  module.exports = TestimonialsGroupController;
}
addEventListener('load', function () {
  var testimonialsGroups = document.querySelectorAll('[data-testimonials-group]');
  testimonialsGroups.forEach(function (testimonialsGroup) {
    var testimonialsGroupController = new TestimonialsGroupController(testimonialsGroup);
    testimonialsGroupController.init();
  });
});